<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: the role is bound dynamically to option, which Biome cannot resolve statically -->
<!-- biome-ignore-all lint/a11y/useKeyWithClickEvents: the combobox trigger owns the keyboard, driving this row through aria-activedescendant -->
<script lang="ts" setup>
  import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { FontIcon } from '../../../FontIcon';
  import CheckboxIndicator from '../../Checkbox/CheckboxIndicator/CheckboxIndicator.vue';
  import {
    optionCheckboxClass,
    optionIconClass,
    optionGroupClass,
    optionLabelClass,
    optionRowActiveClass,
    optionRowClass,
    optionRowDisabledClass,
    optionRowSelectedClass,
    optionRowSelectedSurfaceClass,
  } from './SelectOptionRow.css';

  withDefaults(
    defineProps<{
      label: string;
      selected?: boolean;
      indeterminate?: boolean;
      disabled?: boolean;
      active?: boolean;
      asCheckbox?: boolean;
      isGroup?: boolean;
      selectable?: boolean;
      icon?: TUNDR_ICONS;
      testId?: string;
      rowId?: string;
    }>(),
    { selectable: true },
  );

  const emit = defineEmits<{ select: [] }>();
</script>

<template>
  <div
    :id="rowId"
    :class="[
      optionRowClass,
      { [optionGroupClass]: isGroup },
      { [optionRowSelectedClass]: selected && !isGroup },
      { [optionRowSelectedSurfaceClass]: selected && !asCheckbox && !isGroup },
      { [optionRowActiveClass]: active },
      { [optionRowDisabledClass]: disabled },
    ]"
    :data-test-id="testId"
    :role="isGroup ? 'presentation' : 'option'"
    :aria-selected="isGroup ? undefined : selected"
    :aria-disabled="disabled || undefined"
    @click.stop="!disabled && selectable && emit('select')"
    @mousedown.prevent
  >
    <span v-if="icon" :class="optionIconClass">
      <FontIcon :icon-name="icon" />
    </span>
    <span v-if="asCheckbox" :class="optionCheckboxClass" aria-hidden="true">
      <CheckboxIndicator
        :checked="Boolean(selected)"
        :indeterminate="indeterminate"
        :disabled="disabled"
      />
    </span>
    <span :class="optionLabelClass">{{ label }}</span>
  </div>
</template>
